// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__34dbt","amount":"Amount_amount__1uHOK","tip":"Amount_tip__6GdCn","tipHeader":"Amount_tipHeader__3kvtd","tipsWrap":"Amount_tipsWrap__vgrjZ"};